<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredite grupo:
    </h2>

    <GroupForm
      @save="save"
      @cancel="cancel"
      :taxLevels="taxLevels"
      :taxTypes="taxTypes"
      :group="group"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import GroupForm from '@/components/GroupForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    GroupForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  computed: {
    group () {
      return this.$store.state.groups.items[this.id]
    },
    taxLevels () {
      return objectToArray(this.$store.state.taxLevels.items)
    },
    taxTypes () {
      return objectToArray(this.$store.state.taxTypes.items)
    }
  },
  methods: {
    ...mapActions('groups', ['loadItem', 'saveItem']),
    ...mapActions('taxLevels', { loadTaxLevels: 'loadItems' }),
    ...mapActions('taxTypes', { loadTaxTypes: 'loadItems' }),
    save ({ data }) {
      saveItem(data, 'MyCompanyGroups', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyGroups' })
    }
  },
  created () {
    Promise.all([
      this.loadItem(this.id),
      this.loadTaxLevels(),
      this.loadTaxTypes()
    ])
      .then(items => { this.asyncDataStatus_fetched() })
  }
}
</script>
